import React from 'react'
import { Typography } from '@mui/material'
import Signature from './Signature'
import { getPrimaryOptions, getPrimaryPath } from '../utils'

function parseArray(objectOrArray) {
  if (!objectOrArray) return []

  if (Array.isArray(objectOrArray)) {
    return objectOrArray
  }

  return [objectOrArray]
}

function defineSignaturesParent(parentName) {
  return (signature) => ({
    parent: parentName,
    signature,
  })
}

function SignatureIcon() {
  return (
    <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.3329 16.568C8.22023 16.3367 8.02391 16.3133 7.94446 16.3133C7.86502 16.3133 7.6687 16.3363 7.56175 16.5551L7.2688 17.1543C7.0255 17.6535 6.31279 17.5984 6.14283 17.0727L5.50001 15.1012L5.09477 16.3465C4.8698 17.0363 4.23997 17.5 3.52879 17.5H3.05556C2.71792 17.5 2.44445 17.2203 2.44445 16.875C2.44445 16.5297 2.71792 16.25 3.05556 16.25H3.52879C3.71327 16.25 3.87674 16.1297 3.93518 15.9508L4.62994 13.8164C4.75598 13.4332 5.10508 13.1754 5.50001 13.1754C5.89494 13.1754 6.24404 13.4328 6.3697 13.8164L6.89984 15.443C7.65418 14.8105 8.96464 15.0641 9.42068 15.9961C9.49287 16.1437 9.63037 16.2285 9.77818 16.2406V13.0328L14.6671 8.06836V6.25H9.47224C8.96808 6.25 8.55557 5.82812 8.55557 5.3125V0H0.916669C0.408681 0 0 0.417969 0 0.9375V19.0625C0 19.582 0.408681 20 0.916669 20H13.75C14.258 20 14.6667 19.582 14.6667 19.0625V17.5L9.7778 17.4957C9.1621 17.4836 8.60981 17.1332 8.3329 16.568ZM14.6667 4.76172C14.6667 4.51562 14.5712 4.27734 14.3993 4.10156L10.6601 0.273438C10.4882 0.0976562 10.2552 0 10.0108 0H9.7778V5H14.6667V4.76172ZM11 13.5531V16.25H13.6351L19.8104 9.89141L17.2177 7.23984L11 13.5531ZM21.7151 6.53633L20.4979 5.29141C20.1182 4.90313 19.5021 4.90313 19.1225 5.29141L18.0817 6.35586L20.6743 9.00742L21.7151 7.94297C22.0952 7.55469 22.0952 6.92461 21.7151 6.53633Z" fill="#101212" />
    </svg>
  )
}

function Signatures({ xmlJson }) {
  const isDegree = xmlJson?.Diploma
  const isDA = xmlJson?.DocumentacaoAcademicaRegistro
  const isHistory = xmlJson?.DocumentoHistoricoEscolarFinal || xmlJson?.DocumentoHistoricoEscolarParcial
  const primaryOptions = getPrimaryOptions(xmlJson)
  const [primaryPath] = getPrimaryPath(xmlJson)
  const signaturesRoot = parseArray(
    xmlJson?.[primaryPath]?.['ds:Signature'] || xmlJson?.[primaryPath]?.Signature ||
    null
  )
   // Part: "DadosDiploma", get signatures in DadosDiplomaNSF, DadosDiploma e DadosDiplomaPorDecisaoJudicial, ...
  const findSignaturesByPrimaryOptionPart = (part) => {
    const key = Object.keys(primaryOptions).find(key => key.includes(part))
    if (!key) return parseArray(null)
    const option = primaryOptions[key]
    if (!option) return parseArray(null)
    return parseArray(option['ds:Signature'] || option.Signature || null)
  }

  const signaturesDegree = findSignaturesByPrimaryOptionPart('DadosDiploma')
  const signaturesRegister = findSignaturesByPrimaryOptionPart('DadosRegistro')

  const rootSignatureName = (isDegree || isDA) ? "Assinatura institucional de arquivamento" : "Assinaturas"
  const signatureBlocks = {
    ...(!isHistory ? { 'Assinaturas sobre dados do diplomado': signaturesDegree } : {}),
    ...(isDegree ? { 'Assinaturas sobre dados do registro': signaturesRegister } : {}),
    [rootSignatureName]: signaturesRoot,
  }
  const signaturesLength = signaturesDegree.length + signaturesRegister.length + signaturesRoot.length

  if (!signaturesLength) {
    return (
      <div style={{ padding: 20 }} className="empty-signatures">
        <Typography>Este documento não possui nenhuma assinatura</Typography>
      </div>
    )
  }

  return (
    <div className="signatures-component">
      {Object.entries(signatureBlocks).map(([blockName, signatures], key) => (
        <div key={key} className="signature-block">
          <p className="block-name"><SignatureIcon /> {blockName}</p>
          <div className="signatures-in-block">
            {!signatures.length && <Typography className="signature-component">Nenhuma assinatura para este grupo</Typography>}
            {!!signatures.length && signatures.map((signature, mk) => <Signature key={mk} signature={signature} />)}
          </div>
        </div>
      ))}
    </div>
  )
}

export default Signatures
